import { Spinner } from '@americastestkitchen/mise';
import styles from './joinFlowSpinner.module.scss';

const JoinFlowSpinner = () => (
  <div className={styles.spinnerContainer}>
    <Spinner />
  </div>
);

export default JoinFlowSpinner;
